import {
  Notification,
  NotificationType,
} from "@transfr-inc/dashboard-components";

import { ENTRY_TYPES } from "../ai-curriculum.constants";
import { AiAnalyzerSummary } from "../components";

import { QuickStartFields } from "./quick-start-fields";
import { StandardsFields } from "./standards-fields";
import { SyllabusUploadFields } from "./syllabus-upload-fields";

import "./ai-form.step.scss";

// Renders the shared chrome (illustration + State Standards context summary +
// Upload analyzer summary) and dispatches to the entry-type-specific field
// group.
export const AiFormStep = ({
  entryType,
  standardsContext,
  analyzerSummary,
  criteria,
  errors = {},
  error,
  onChange,
}) => {
  const isQuickStart = entryType === ENTRY_TYPES.QUICK_START;
  const isUpload = entryType === ENTRY_TYPES.SYLLABUS_UPLOAD;

  return (
    <div className="ai-form-step">
      {error && (
        <Notification type={NotificationType.error}>{error}</Notification>
      )}

      <div className="ai-form-step__illustration">
        <img src="/images/ai-curriculum/short.png" alt="" />
      </div>

      {standardsContext && (
        <div className="ai-form-step__context">
          <div className="ai-form-step__context-item">
            <span className="ai-form-step__context-label">State</span>
            <span className="ai-form-step__context-value">
              {standardsContext.state}
            </span>
          </div>
          <div className="ai-form-step__context-item">
            <span className="ai-form-step__context-label">Subject</span>
            <span className="ai-form-step__context-value">
              {standardsContext.subject}
            </span>
          </div>
          {standardsContext.sourceName && (
            <div className="ai-form-step__context-item">
              <span className="ai-form-step__context-label">Framework</span>
              <span className="ai-form-step__context-value">
                {standardsContext.sourceName}
              </span>
            </div>
          )}
        </div>
      )}

      {isUpload && <AiAnalyzerSummary summary={analyzerSummary} />}

      <p className="ai-form-step__required-note">Required Fields *</p>

      {isQuickStart && (
        <QuickStartFields
          criteria={criteria}
          errors={errors}
          onChange={onChange}
        />
      )}
      {isUpload && (
        <SyllabusUploadFields
          criteria={criteria}
          errors={errors}
          onChange={onChange}
        />
      )}
      {!isQuickStart && !isUpload && (
        <StandardsFields criteria={criteria} onChange={onChange} />
      )}
    </div>
  );
};
